import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMedicalCrossCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedicalCrossCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13.5 10.5V7.5H10.5V10.5H7.5V13.5H10.5V16.5H13.5V13.5H16.5V10.5H13.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMedicalCrossCircle;
